import { apiAxios } from "./apiConfig";

/* =====================================================
   ACTIVITY LIST
===================================================== */

export interface Activity {
  id: string;
  activityName: string;
  activityDescription: string;
  activityLogoName: string;
  isMessageTemplateMetric: boolean;
  goal: number;
  goalUnit: string;
  activityOption: string[];
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface ActivityListResponse {
  status: boolean;
  data: Activity[];
}

export const getActivityList = async (): Promise<ActivityListResponse> => {
  const response = await apiAxios.get("/activity/list");
  return response.data;
};
